// extracted by mini-css-extract-plugin
module.exports = {"sponsorContainer":"Sponsor_sponsorContainer__2C6aO","sponsorImage":"Sponsor_sponsorImage__7bEhT"};